var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var Dom = function () {
            function Dom() {
                _classCallCheck(this, Dom);

                this.NullElement = null;
            }

            /**
             * @param {string} selector
             * @param parent
             */


            _createClass(Dom, [{
                key: "safeQuery",
                value: function safeQuery(selector) {
                    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

                    var nodes = parent.querySelectorAll(selector);

                    if (nodes.length === 1) {
                        return nodes[0];
                    }

                    if (nodes.length === 0) {
                        return undefined;
                    }

                    return nodes;
                }
            }, {
                key: "toggleClass",
                value: function toggleClass(selector, className) {
                    if (selector.classList.contains(className)) {
                        selector.classList.remove(className);
                    } else {
                        selector.classList.add(className);
                    }
                }
            }]);

            return Dom;
        }();

        window.Dom = new Dom();

        window.Dom.NullElement = {
            classList: {
                add: function add() {},
                remove: function remove() {},
                toggle: function toggle() {},
                contains: function contains() {
                    return false;
                }
            },
            addEventListener: function addEventListener() {},
            removeEventListener: function removeEventListener() {},
            setAttribute: function setAttribute() {},
            getAttribute: function getAttribute() {
                return null;
            },

            style: {},
            dataset: {},

            querySelector: function querySelector() {
                console.error("[Dom.NullElement] querySelector used on NullElement");
                return window.Dom.NullElement;
            },
            querySelectorAll: function querySelectorAll() {
                console.error("[Dom.NullElement] querySelectorAll used on NullElement");
                return [];
            },
            appendChild: function appendChild() {},
            remove: function remove() {},

            innerHTML: '',
            textContent: ''
        };

        window.QS = window.Dom.safeQuery.bind(window.Dom);
        window.$toggleClass = window.Dom.toggleClass.bind(window.Dom);
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var Ajax = function () {
            function Ajax() {
                _classCallCheck(this, Ajax);

                this.csrfParam = this.getCsrfParam();
                this.csrfToken = this.getCsrfToken();
            }

            /**
             * @return string|undefined the CSRF parameter name. Undefined is returned if CSRF validation is not enabled.
             */


            _createClass(Ajax, [{
                key: "getCsrfParam",
                value: function getCsrfParam() {
                    var csrfParamMeta = document.querySelector('meta[name="csrf-param"]');
                    return csrfParamMeta ? csrfParamMeta.content : undefined;
                }

                /**
                 * @return string|undefined the CSRF token. Undefined is returned if CSRF validation is not enabled.
                 */

            }, {
                key: "getCsrfToken",
                value: function getCsrfToken() {
                    var csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
                    return csrfTokenMeta ? csrfTokenMeta.content : undefined;
                }

                /**
                 * Sets the CSRF token in the meta elements.
                 * This method is provided so that you can update the CSRF token with the latest one you obtain from the server.
                 * @param {string} name the CSRF token name
                 * @param {string} value the CSRF token value
                 */

            }, {
                key: "setCsrfToken",
                value: function setCsrfToken(name, value) {
                    var csrfParamMeta = document.querySelector('meta[name="csrf-param"]');
                    var csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');

                    if (csrfParamMeta) csrfParamMeta.content = name;
                    if (csrfTokenMeta) csrfTokenMeta.content = value;
                }

                /**
                 * Updates all form CSRF input fields with the latest CSRF token.
                 * This method is provided to avoid cached forms containing outdated CSRF tokens.
                 */

            }, {
                key: "refreshCsrfToken",
                value: function refreshCsrfToken() {
                    var token = this.getCsrfToken();
                    if (token) {
                        var csrfParam = this.getCsrfParam();
                        document.querySelectorAll("form input[name=\"" + csrfParam + "\"]").forEach(function (input) {
                            input.value = token;
                        });
                    }
                }

                /**
                 * Initializes the CSRF handler to automatically send CSRF token with all AJAX requests.
                 */

            }, {
                key: "initCsrfHandler",
                value: function initCsrfHandler() {
                    var _this = this;

                    // Automatically send CSRF token for all fetch requests
                    var originalFetch = window.fetch;
                    window.fetch = function (input, init) {
                        if (typeof input === 'string' && !input.startsWith('http')) {
                            init = init || {};
                            init.headers = init.headers || {};
                            if (_this.getCsrfParam()) {
                                init.headers['X-CSRF-Token'] = _this.getCsrfToken();
                            }
                        }
                        return originalFetch(input, init);
                    };

                    this.refreshCsrfToken();
                }
            }, {
                key: "post",
                value: function post(url, requestInit, callback) {
                    var params = requestInit.params || {};
                    params._csrf = this.csrfToken;
                    var body = JSON.stringify(params);

                    var fetchOptions = {
                        method: "POST",
                        headers: {
                            "X-CSRF-Token": this.csrfToken,
                            "Content-Type": "application/json",
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-Language': document.documentElement.lang
                        },
                        body: body
                    };

                    this._postFetch(url, fetchOptions, callback);
                }
            }, {
                key: "get",
                value: function get(url, requestInit, onSuccess) {
                    var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

                    var urlWithParams = new URL(url, window.location.origin);

                    if (requestInit.params) {
                        Object.keys(requestInit.params).forEach(function (key) {
                            urlWithParams.searchParams.append(key, requestInit.params[key]);
                        });
                    }

                    var fetchOptions = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Language": document.documentElement.lang
                        }
                    };

                    fetch(urlWithParams, fetchOptions).then(function (response) {
                        if (!response.ok) {
                            throw new Error("HTTP " + response.status);
                        }
                        return response.json();
                    }).then(function (data) {
                        onSuccess(data);
                    }).catch(function (error) {
                        console.error("Request failed", error);
                        if (typeof onError === "function") {
                            onError(error);
                        }
                    });
                }
            }, {
                key: "getHtml",
                value: function getHtml(url, requestInit, callback) {
                    var urlWithParams = new URL(url, window.location.origin);
                    if (requestInit.params) {
                        Object.keys(requestInit.params).forEach(function (key) {
                            return urlWithParams.searchParams.append(key, requestInit.params[key]);
                        });
                    }

                    var fetchOptions = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/html"
                        }
                    };

                    fetch(urlWithParams, fetchOptions).then(function (response) {
                        return response.text();
                    }).then(function (data) {
                        callback(data);
                    }).catch(function (reason) {
                        console.log("Request failed", reason);
                    });
                }
            }, {
                key: "fileData",
                value: function fileData(url, requestInit, callback) {
                    requestInit.body.append('_csrf', this.csrfToken);

                    var fetchOptions = {
                        method: "POST",
                        body: requestInit.body,
                        headers: {
                            "X-CSRF-Token": this.csrfToken
                        }
                    };

                    this._postFetch(url, fetchOptions, callback);
                }
            }, {
                key: "_postFetch",
                value: function _postFetch(url, fetchOptions, callback) {
                    var _this2 = this;

                    fetch(url, fetchOptions).then(function (response) {
                        return response.json();
                    }).then(function (data) {
                        callback(data);

                        if (data._csrf) {
                            _this2.setCsrfToken(_this2.csrfParam, data._csrf);
                            _this2.csrfToken = data._csrf;
                            _this2.refreshCsrfToken();
                        }
                    }).catch(function (reason) {
                        console.log("Request failed", reason);
                    });
                }
            }]);

            return Ajax;
        }();

        // Привязка к объекту window


        window.ajax = new Ajax();
        window.ajax.initCsrfHandler();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var EventDispatcher = function () {
            function EventDispatcher() {
                _classCallCheck(this, EventDispatcher);

                this.listeners = {};
            }

            // Добавит событие для прослушивания


            _createClass(EventDispatcher, [{
                key: "addEventListener",
                value: function addEventListener(eventName, callback) {
                    if (!this.listeners[eventName]) {
                        this.listeners[eventName] = [];
                    }
                    this.listeners[eventName].push(callback);

                    return this;
                }

                // Удалить события из прослушивания

            }, {
                key: "removeEventListener",
                value: function removeEventListener(eventName, callback) {
                    if (this.listeners[eventName]) {
                        this.listeners[eventName] = this.listeners[eventName].filter(function (listener) {
                            return listener !== callback;
                        });
                    }

                    return this;
                }

                // Слушает когда выполнится событие

            }, {
                key: "dispatchEvent",
                value: function dispatchEvent(eventName, data) {
                    if (this.listeners[eventName]) {
                        this.listeners[eventName].forEach(function (callback) {
                            return callback(data);
                        });
                    }

                    return this;
                }
            }, {
                key: "addEvent",
                value: function addEvent(event, selector, callback) {
                    var element = document.querySelector(selector);

                    if (element) {
                        element.addEventListener(event, callback);
                    }

                    return this;
                }
            }, {
                key: "addAllEvent",
                value: function addAllEvent(event, selector, callback) {
                    var elements = document.querySelectorAll(selector);

                    if (elements.length > 0) {
                        elements.forEach(function (element) {
                            element.addEventListener(event, callback);
                        });
                    }

                    return this;
                }
            }, {
                key: "on",
                value: function on(event, selector, callback) {
                    document.body.addEventListener(event, function (e) {
                        var targetElement = e.target.matches(selector) ? e.target : e.target.closest(selector);

                        if (targetElement) {
                            callback(e, targetElement);
                        }
                    });

                    return this;
                }
            }]);

            return EventDispatcher;
        }();

        // Привязка к объекту window


        window.eventDispatcher = new EventDispatcher();
        window.$event = new EventDispatcher();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        (function () {
            var owners = new Set();
            var loader = null;
            var navigationTimer = null;

            window.showPageLoader = function () {
                var owner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'manual';

                owners.add(owner);
                if (loader) {
                    return;
                }

                var texts = window.app.loader;
                loader = document.createElement('div');
                loader.className = 'site-page-loader';
                loader.setAttribute('role', 'status');
                loader.setAttribute('aria-live', 'polite');
                var content = document.createElement('div');
                content.className = 'site-page-loader__content';
                var spinner = document.createElement('span');
                spinner.className = 'site-page-loader__spinner';
                spinner.setAttribute('aria-hidden', 'true');
                var title = document.createElement('div');
                title.className = 'site-page-loader__title';
                title.textContent = texts.title;
                var subtitle = document.createElement('div');
                subtitle.className = 'site-page-loader__subtitle';
                subtitle.textContent = texts.subtitle;
                content.appendChild(spinner);
                content.appendChild(title);
                content.appendChild(subtitle);
                loader.appendChild(content);
                document.body.appendChild(loader);
                document.body.classList.add('site-page-loading');
            };

            window.hidePageLoader = function () {
                var owner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'manual';

                owners.delete(owner);
                if (owners.size) {
                    return;
                }
                if (loader) {
                    loader.remove();
                    loader = null;
                }
                document.body.classList.remove('site-page-loading');
            };

            function reset() {
                clearTimeout(navigationTimer);
                owners.clear();
                window.hidePageLoader();
            }

            function navigation() {
                window.showPageLoader('navigation');
                clearTimeout(navigationTimer);
                // A cancelled navigation or a download response must not leave the page blocked.
                navigationTimer = setTimeout(function () {
                    return window.hidePageLoader('navigation');
                }, 15000);
            }

            function targetsCurrentPage(target) {
                var base = document.querySelector('base[target]');
                target = target || base && base.getAttribute('target') || '_self';
                return target.toLowerCase() === '_self';
            }

            document.addEventListener('click', function (event) {
                if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
                    return;
                }
                var link = event.target.closest('a[href]');
                if (!link || link.hasAttribute('download') || !targetsCurrentPage(link.getAttribute('target'))) {
                    return;
                }
                var url = new URL(link.href, document.baseURI);
                if (!/^https?:$/.test(url.protocol)) {
                    return;
                }
                if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search && link.getAttribute('href').indexOf('#') !== -1) {
                    return;
                }
                // Let delegated handlers cancel modal, AJAX and client-side router links first.
                setTimeout(function () {
                    if (!event.defaultPrevented) {
                        navigation();
                    }
                }, 0);
            });

            document.addEventListener('submit', function (event) {
                var form = event.target;
                var submitter = event.submitter;
                var target = submitter && submitter.getAttribute('formtarget');
                var method = submitter && submitter.getAttribute('formmethod') || form.getAttribute('method');
                if (!targetsCurrentPage(target || form.getAttribute('target')) || method === 'dialog') {
                    return;
                }
                setTimeout(function () {
                    if (!event.defaultPrevented) {
                        navigation();
                    }
                }, 0);
            });

            // Includes location.assign/replace, reload and native form.submit().
            window.addEventListener('beforeunload', function (event) {
                if (!event.defaultPrevented) {
                    navigation();
                }
            });
            window.addEventListener('pageshow', reset);
            window.addEventListener('pagehide', reset);
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible') {
                    clearTimeout(navigationTimer);
                    window.hidePageLoader('navigation');
                    // Legacy callers show the manual loader before opening a messenger app.
                    window.hidePageLoader();
                }
            });
        })();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        eventDispatcher.addEventListener('toggleBtnLoading', function (data) {
            if (data.target) {
                if (data.isShow) {
                    if (data.content) {
                        data.target.insertAdjacentHTML('beforeend', '<div class="loader-content">' + data.content + '</div>');
                    } else {
                        data.target.dataset.loading = app.loader ? app.loader.btnLoaderText : 'Loading';
                    }

                    data.target.classList.add('loading');
                    data.target.disabled = true;
                } else {
                    data.target.classList.remove('loading');
                    data.target.disabled = false;

                    if (document.querySelector('.loader-content')) {
                        document.querySelector('.loader-content').remove();
                    }
                }
            }
        });

        eventDispatcher.addEventListener('_block-page', function () {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { enable: true };

            if (params.enable) {
                window.showPageLoader('block-page');
            } else {
                window.hidePageLoader('block-page');
            }
        });

        eventDispatcher.addEventListener('_load-content', function () {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                enable: true,
                position: 'beforeend'
            };

            var body = document.querySelector(params.target);
            var loader = document.querySelector('.lds-ring');

            if (params.enable) {
                body.classList.add('block-page');
                body.insertAdjacentHTML(params.position, '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>');
            } else if (loader) {
                body.classList.remove('block-page');
                loader.remove();
            }
        });

        eventDispatcher.addAllEvent('click', '.js-close-modal-old', function () {
            eventDispatcher.dispatchEvent('_close-modal');
        });

        eventDispatcher.on('click', '.send-analytic-event', function (event, element) {
            var eventName = element.getAttribute('data-event');
            if (eventName && window.brxTracking) {
                var eventProperties = {};
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.entries(element.dataset)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ref = _step.value;

                        var _ref2 = _slicedToArray(_ref, 2);

                        var key = _ref2[0];
                        var value = _ref2[1];

                        if (key.startsWith('event')) {
                            var cleanKey = key.slice(5); // убираем event
                            if (cleanKey) {
                                // первая буква всегда большая
                                cleanKey = cleanKey.charAt(0).toUpperCase() + cleanKey.slice(1);
                                // чтобы пустую строку пропустить
                                eventProperties[cleanKey] = value;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                window.brxTracking.sendAnalyticsEvent(eventName, eventProperties);
            }
        });

        // Смена валюты на сайте
        eventDispatcher.on('click', '.js-set-currency', function (event, element) {
            event.preventDefault();
            var currency = element.dataset.value;
            window.utils.setCurrency(currency);
        });

        // Смена языка на сайте
        eventDispatcher.on('click', '.js-set-language', function (event, element) {
            var language = element.dataset.value;

            if (!language) {
                return;
            }

            event.preventDefault();
            document.cookie = "current_lang=" + encodeURIComponent(language) + "; path=/; max-age=2592000";
            window.location.replace(element.href);
        });

        document.addEventListener('DOMContentLoaded', function () {
            var url = new URL(window.location.href);

            if (!url.searchParams.has('set_language')) {
                return;
            }

            url.searchParams.delete('set_language');
            window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var SiteFormData = function () {
            function SiteFormData() {
                _classCallCheck(this, SiteFormData);

                this.form = null;

                this.handlers();
            }

            _createClass(SiteFormData, [{
                key: "handlers",
                value: function handlers() {
                    var _this3 = this;

                    window.eventDispatcher.addEventListener('_validate-form', function (data) {
                        _this3.form = data.form;
                        var formData = new FormData(_this3.form);
                        var params = _this3.getFormData(formData);

                        _this3.validate(params);
                    });

                    window.eventDispatcher.addEventListener('_reset-form-errors', function (data) {
                        _this3.form = data.form;
                        _this3.beforeMarkErrorsField();
                    });
                }
            }, {
                key: "validate",
                value: function validate(params) {
                    var _this4 = this;

                    this.beforeMarkErrorsField();

                    window.ajax.post(this.form.action, { params: params }, function (data) {
                        if (data.success) {
                            window.eventDispatcher.dispatchEvent('_is-validate-form', {
                                isValid: true,
                                form: _this4.form
                            });
                        } else {
                            if (data.errors) {
                                _this4.setErrors(data.errors);
                                window.eventDispatcher.dispatchEvent('_is-validate-form', {
                                    isValid: false,
                                    form: _this4.form
                                });
                            }
                        }
                    });
                }
            }, {
                key: "getFormData",
                value: function getFormData(formData) {
                    var data = {};

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = formData.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var key = _step2.value;

                            var keys = key.replace(/\]/g, '').split('[');
                            var obj = data;

                            for (var i = 0; i < keys.length; i++) {
                                var currentKey = keys[i];
                                if (i === keys.length - 1) {
                                    obj[currentKey] = formData.get(key);
                                } else {
                                    obj[currentKey] = obj[currentKey] || {};
                                    obj = obj[currentKey];
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    return data;
                }
            }, {
                key: "beforeMarkErrorsField",
                value: function beforeMarkErrorsField() {
                    var formGroup = this.form.querySelectorAll('.form-group');
                    //const defaultErrors = document.querySelector('.default-errors');
                    //defaultErrors.innerHTML = '';

                    formGroup.forEach(function (item) {
                        if (!item.classList.contains('error')) {
                            return;
                        }

                        item.classList.remove('error');
                        item.querySelector('.error-text').remove();
                    });
                }
            }, {
                key: "setErrors",
                value: function setErrors(errors) {
                    var formFields = this.form.querySelectorAll('.form-group .form-control');
                    this.markErrorsField(formFields, errors);
                }
            }, {
                key: "markErrorsField",
                value: function markErrorsField(formFields, errors) {
                    for (var formName in errors) {
                        var formErrors = errors[formName];
                        for (var errorKey in formErrors) {
                            var fieldErrors = formErrors[errorKey];
                            for (var fieldKey in fieldErrors) {
                                for (var i = 0; i < formFields.length; i++) {
                                    if (formFields[i].name === this.form.name + '[' + fieldKey + ']') {
                                        var formGroup = formFields[i].closest('.form-group');
                                        var errorText = document.createElement('div');
                                        errorText.className = 'error-text';
                                        errorText.innerText = fieldErrors[fieldKey][0]; // Берем первый элемент из массива ошибок
                                        formFields[i].after(errorText);
                                        formGroup.classList.add('error');
                                    }
                                }
                            }
                        }
                    }
                }
            }]);

            return SiteFormData;
        }();

        module.exports = SiteFormData;

        new SiteFormData();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        window.utils = {
            isElementInViewport: function isElementInViewport(el) {
                var rect = el.getBoundingClientRect();
                return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            },
            /**
             * см ShareData
             * @param {{
             *   title: string;
             *   text?: string;
             *   url?: string;
             *   files?: File[];
             * }} data
             * @param messageOnSuccessCopy
             */
            share: function share(data) {
                var messageOnSuccessCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var shareData = {
                    title: data.title
                };
                if (data.url && !navigator.share) {
                    shareData.url = data.url;
                }
                if (data.text) {
                    shareData.text = data.text;
                }

                if (navigator.share) {
                    navigator.share(shareData).catch(function (error) {
                        console.log('Error sharing:', error);
                        var copyText = data.text || '';
                        window.brxUtils.copyToClipBoard(copyText, messageOnSuccessCopy);
                    });
                } else {
                    var copyText = shareData.url || data.text;
                    window.brxUtils.copyToClipBoard(copyText, messageOnSuccessCopy);
                }
            },
            /**
             * @param {string} text
             * @param {string|null} messageOnSuccess
             */
            copyToClipBoard: function copyToClipBoard(text) {
                var messageOnSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var bufferField = document.createElement('textarea');
                document.body.appendChild(bufferField);
                bufferField.value = text;
                bufferField.select();
                document.execCommand('copy');
                document.body.removeChild(bufferField);
                // eslint-disable-next-line no-alert
                window.alert(messageOnSuccess || 'Ссылка скопирована в буфер обмена.');
            },
            /**
             * Функция для форматирования номера телефона в формате +7 707 707-77-77
             * @param {string} phone
             * @return {string}
             */
            beautifyMobilePhoneNumber: function beautifyMobilePhoneNumber(phone) {
                if (/^\d+$/.test(phone)) {
                    return phone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '+$1 $2 $3-$4-$5');
                }

                return phone;
            },
            /**
             * Функция для смены валюты сайта
             * @param {string} currency
             */
            setCurrency: function setCurrency(currency) {
                ajax.post(window.app.links.setCurrency, { params: { current_currency: currency } }, function () {
                    eventDispatcher.dispatchEvent('_block-page');
                    var url = new URL(window.location.href);

                    url.searchParams.delete('location');
                    if (url.href === window.location.href) {
                        window.location.reload();
                    } else {
                        window.location.replace(url.href);
                    }
                });
            },
            getnoun: function getnoun(number, one, two, five) {
                var glue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

                number = Math.abs(number);
                number = number % 100;
                glue = glue ? '' + number + ' ' : '';
                if (number >= 5 && number <= 20) {
                    return glue + five;
                }

                number = number % 10;
                if (number === 1) {
                    return glue + one;
                }

                if (number >= 2 && number <= 4) {
                    return glue + two;
                }

                return glue + five;
            },
            numSpaceFormat: function numSpaceFormat(number) {
                return number.toLocaleString('ru-RU');
            }
        };

        window.brxUtils = window.utils;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // Vanilla JS Only!
        var onDOMContentLoaded = function onDOMContentLoaded() {
            // При попадании блока в область видимости, загрузить картинку|установить фон
            var lazyBackgroundClass = 'lazy-img-bg-watch';
            // При попадании img в область видимости, загрузить картинку
            var lazyImageClass = 'lazy-img-watch';

            var lazyBackgrounds = [].slice.call(document.querySelectorAll('.' + lazyBackgroundClass));
            if ('IntersectionObserver' in window && lazyBackgrounds.length) {
                /**
                 * @param {IntersectionObserverEntry[]} entries
                 * @param {IntersectionObserver} observer
                 */
                var lazyBackgroundObserverCallback = function lazyBackgroundObserverCallback(entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            // lazy backgroundImage
                            entry.target.style.backgroundImage = "url(" + entry.target.dataset.src + ")";
                            entry.target.classList.remove(lazyBackgroundClass);
                            observer.unobserve(entry.target);
                        }
                    });
                };
                var lazyBackgroundObserver = new IntersectionObserver(lazyBackgroundObserverCallback);
                var registerObserverEntries = function registerObserverEntries() {
                    lazyBackgrounds.forEach(function (lazyBackground) {
                        lazyBackgroundObserver.observe(lazyBackground);
                    });
                };
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(registerObserverEntries);
                } else {
                    registerObserverEntries();
                }
            }

            var lazyImages = [].slice.call(document.querySelectorAll('img.' + lazyImageClass));
            if (lazyImages.length) {
                var active = false;
                var lazyLoad = function lazyLoad() {
                    if (active === false) {
                        active = true;

                        setTimeout(function () {
                            lazyImages.forEach(function (lazyImage) {
                                if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {
                                    if (lazyImage.offsetParent) {
                                        lazyImage.src = lazyImage.dataset.src;
                                        lazyImage.classList.remove(lazyImageClass);
                                        lazyImage.dataset.loaded = '1';
                                    }
                                }
                            });

                            lazyImages = lazyImages.filter(function (image) {
                                return image.dataset.loaded !== '1';
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('resize', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }

                            active = false;
                        }, 200);
                    }
                };

                document.addEventListener('scroll', lazyLoad);
                window.addEventListener('resize', lazyLoad);
                window.addEventListener('orientationchange', lazyLoad);
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(lazyLoad);
                } else {
                    lazyLoad();
                }

                document.querySelectorAll('.mpopup .mpopup_content').forEach(function (modal) {
                    modal.addEventListener('scroll', lazyLoad);
                });
            }

            document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
        };
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

        window.brxLazyImage = {
            /**
             * @param {HTMLImageElement|Element} lazyImgOrBg
             * @param {boolean} isImg
             */
            load: function load(lazyImgOrBg, isImg) {
                if (isImg) {
                    lazyImgOrBg.src = lazyImgOrBg.dataset.src;
                    lazyImgOrBg.classList.remove('lazy-img');
                    lazyImgOrBg.removeAttribute('data-src');
                } else {
                    lazyImgOrBg.style.backgroundImage = "url(" + lazyImgOrBg.dataset.src + ")";
                    lazyImgOrBg.classList.remove('lazy-img-bg');
                    lazyImgOrBg.removeAttribute('data-src');
                }
            },
            /**
             * @param {Element} parentElem
             * @param {boolean} img  Загрузить img
             * @param {boolean} background Загрузить bg
             */
            loadChildren: function loadChildren(parentElem) {
                var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var background = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                if (!parentElem) {
                    return;
                }
                if (img) {
                    parentElem.querySelectorAll('img.lazy-img').forEach(function (lazyImage) {
                        window.brxLazyImage.load(lazyImage, true);
                    });
                }
                if (background) {
                    parentElem.querySelectorAll('.lazy-img-bg').forEach(function (lazyImageBg) {
                        window.brxLazyImage.load(lazyImageBg, false);
                    });
                }
            }
        };

        (function () {
            var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    window.brxLazyImage.load(entry.target, true);
                    entry.target.classList.remove('lazy-img-observe');
                    observer.unobserve(entry.target);
                });
            }, { rootMargin: '0px' }) : null;

            window.brxLazyImage.observe = function () {
                var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                root.querySelectorAll('img.lazy-img-observe[data-src]').forEach(function (image) {
                    if (observer) observer.observe(image);else window.brxLazyImage.load(image, true);
                });
            };
        })();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        'use strict';

        var slice = Array.prototype.slice;

        function getPluralNoun(num) {
            var forms = slice.call(arguments, 1);

            var str;

            switch (forms.length) {
                case 1:
                    throw new Error('Not enough forms');
                    break;

                case 2:
                    str = num > 1 ? forms[1] : forms[0];
                    break;

                default:
                    str = forms[getNounPluralForm(num)];
                    break;
            }

            return str.replace(/%d/g, num);
        }

        function getPluralVerb(num) {
            var forms = slice.call(arguments, 1);
            var str = forms[getVerbPluralForm(num)];

            return str.replace(/%d/g, num);
        }

        function getVerbPluralForm(a) {
            if (a > 1000000) {
                return 2;
            }

            if (a > 1000 && a < 1000000 && /000$/.test(a)) {
                a /= 1000;
            }

            if (a % 10 === 1 && a % 100 !== 11 || /1000$/.test(a.toString())) {
                return 0;
            } else if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
                return 1;
            } else {
                return 2;
            }
        }

        function getNounPluralForm(a) {
            if (a % 10 === 1 && a % 100 !== 11) {
                return 0;
            } else if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
                return 1;
            } else {
                return 2;
            }
        }

        window.plural = getPluralNoun;
        window.getPluralVerb = getPluralVerb;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var pending = new Map();

            function loadAsset(url, type) {
                var absoluteUrl = new URL(url, document.baseURI).href;
                var key = type + ':' + absoluteUrl;
                if (pending.has(key)) return pending.get(key);

                var promise = new Promise(function (resolve, reject) {
                    var attribute = type === 'script' ? 'src' : 'href';
                    var selector = type === 'script' ? 'script[src]' : 'link[rel="stylesheet"]';
                    var node = Array.from(document.querySelectorAll(selector)).find(function (item) {
                        return item[attribute] === absoluteUrl;
                    });
                    if (node && (node.dataset.resourceLoaded === '1' || type === 'style' && node.sheet)) {
                        resolve();return;
                    }
                    var isNew = !node;
                    if (isNew) {
                        node = document.createElement(type === 'script' ? 'script' : 'link');
                        node[attribute] = absoluteUrl;
                        if (type === 'script') node.async = true;else node.rel = 'stylesheet';
                    }
                    node.addEventListener('load', function () {
                        node.dataset.resourceLoaded = '1';resolve();
                    }, { once: true });
                    node.addEventListener('error', function () {
                        node.remove();reject(new Error('Resource loading failed: ' + absoluteUrl));
                    }, { once: true });
                    if (isNew) document.head.appendChild(node);
                }).catch(function (error) {
                    pending.delete(key);throw error;
                });
                pending.set(key, promise);
                return promise;
            }

            window.loadExternalScript = function (url) {
                return loadAsset(url, 'script');
            };
            window.loadExternalStylesheet = function (url) {
                return loadAsset(url, 'style');
            };
            window.loadGoogleMaps = function (apiKey) {
                if (window.google && window.google.maps) return Promise.resolve();
                var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
                return window.loadExternalScript(existing ? existing.src : 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey));
            };
        })();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        window.addEventListener("pageshow", function () {
            eventDispatcher.dispatchEvent('_block-page', {
                enable: false
            });
        });

        window.getCookieByName = function (name) {
            var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : null;
        };

        window.eventDispatcher.addEvent('click', '.hotel__share-button', function (e) {
            var target = e.currentTarget;
            var eventPage = target.dataset.page;
            var eventProperties = { Page: eventPage };
            window.brxUtils.share({
                title: window.app.host,
                text: e.currentTarget.getAttribute('data-share-text') + ' ' + window.location.href,
                url: window.location.href
            });
            window.brxTracking.sendAnalyticsEvent('click_share_button', eventProperties);
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var RecalculateTourManager = require('../recalculate-tour-manager');

        eventDispatcher.addEventListener('_recalc-tour', function (data) {
            var bookingAdvantagesModalVariant = window.getCookieByName('mobile-booking-advantages-modal-after-next-step') || 'show';
            var showBookingAdvantagesModal = bookingAdvantagesModalVariant === 'show';
            var bookingLinkElement = document.querySelector('.js-open-booking');
            var bookingLink = bookingLinkElement ? bookingLinkElement.getAttribute('href') : '/reservation/' + window.tourViewData.tourId + '/booking';
            var getElement = function getElement(selector) {
                return document.querySelector(selector);
            };

            var isMobile = data.isMobile;
            var isGds = data.isGds;
            var tourIdParentElemClass = data.tourIdParentElemClass;
            var tourIdTargetElemClass = data.tourIdTargetElemClass;
            var flightIdsParentElemClass = data.flightIdsParentElemClass;
            var flightIdsTargetElemClass = data.flightIdsTargetElemClass;
            var buttonNextStep = getElement(data.buttonNextStep);
            var finalNextStepButton = getElement(data.finalNextStepButton);
            var currentCashbackSumLabel = getElement(data.currentCashbackSumLabel);
            var currentPriceLabel = getElement(data.currentPriceLabel);
            var currentPriceValueElement = getElement(data.currentPriceValue);
            var currentPriceValue = currentPriceValueElement.value;
            var priceChangedBlock = getElement(data.priceChangedBlock);
            var priceRestLabel = getElement(data.priceRestLabel);

            var isChangeFlight = data && data.isChangeFlight ? data.isChangeFlight : false;
            var isPriceChecked = data && data.isPriceChecked ? data.isPriceChecked : false;

            var isAuto = data.isAuto ? data.isAuto : false;
            var priceStatus = 'actual';

            // Устанавливаем таймер на 10 секунд, столько максимально можно ждать ответа
            var maxTimeResponse = setTimeout(function () {
                handleRecalculateError(new Error('Response timeout'));
            }, isGds === '1' ? 30000 : 15000);

            function nextStepClickProcess() {
                if (!showBookingAdvantagesModal) {
                    window.showPageLoader();
                    window.location.href = bookingLink;
                }
            }

            function dispatchRecalculateStatus(status, isTourPriceIncreased) {
                var priceDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var currencySign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                eventDispatcher.dispatchEvent('_recalc-tour-is-increased', {
                    isTourPriceIncreased: isTourPriceIncreased,
                    status: status,
                    priceDifference: priceDifference,
                    currencySign: currencySign
                });
            }

            function showNotActualTour(response) {
                if (!response.notActualTour) {
                    return false;
                }

                if (!isMobile) {
                    eventDispatcher.dispatchEvent('showTourExpired', response.notActualTour);
                    return true;
                }

                var page = document.querySelector('.mobile-online-booking');
                var fixedPanel = document.querySelector('.fixed-panel');
                var existingStatus = document.querySelector('.tour-status-wrapper');

                if (existingStatus) {
                    existingStatus.remove();
                }

                if (page) {
                    page.insertAdjacentHTML('beforebegin', response.notActualTour);
                    page.classList.add('blur');
                }

                if (fixedPanel) {
                    fixedPanel.classList.add('hide');
                }

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });

                return true;
            }

            function completeAsActualWithoutPriceChange() {
                if (priceChangedBlock) {
                    priceChangedBlock.classList.add('hide');
                }

                if (isMobile && finalNextStepButton) {
                    if (!isChangeFlight) {
                        nextStepClickProcess();
                    }
                }

                if (!isMobile) {
                    dispatchRecalculateStatus('actual', false);
                }

                buttonNextStep.disabled = false;
                buttonNextStep.classList.remove('loader-btn');
            }

            if (!isPriceChecked) {
                showLoader();
                recalculateTour(function (data) {
                    clearTimeout(maxTimeResponse); // Очистка таймера, если ответ пришел вовремя
                    handleRecalculateSuccess(data);
                }, function (error) {
                    clearTimeout(maxTimeResponse); // Очистка таймера в случае ошибки
                    handleRecalculateError(error);
                }, tourIdParentElemClass, tourIdTargetElemClass, flightIdsParentElemClass, flightIdsTargetElemClass, isAuto);
            } else {
                clearTimeout(maxTimeResponse);
                if (isMobile && finalNextStepButton) {
                    nextStepClickProcess();
                }
            }

            function showLoader() {
                buttonNextStep.disabled = true;
                buttonNextStep.textContent = 'Проверяем цену...';
                buttonNextStep.classList.add('loader-btn');
                priceChangedBlock.classList.add('hide');
            }

            function handleRecalculateSuccess(data) {
                buttonNextStep.textContent = 'Следующий шаг';
                var response = data.responseData;
                var responsePriceValue = response.totalPrice ? Number(response.totalPrice.replace(/\D/g, '')) : 0;
                var responseCashbackValue = response.bonusesForTour ? Number(response.bonusesForTour.replace(/\D/g, '')) : 0;
                var hasRecalculatedPrice = Boolean(response.isTourCalculated && response.totalPrice && response.currencySign && responsePriceValue > 0);

                if (response.isActual && hasRecalculatedPrice && responsePriceValue !== Number(currentPriceValue)) {
                    if (isMobile) {
                        window.scrollTo({
                            top: 85,
                            behavior: 'smooth'
                        });
                    }

                    var priceChangedTitle = priceRestLabel ? priceRestLabel.closest('.main-text, .tour-price-changed-block__title') : null;
                    var str = priceChangedTitle ? priceChangedTitle.querySelector('.change-str') : null;
                    var priceChangedContainer = priceRestLabel ? priceRestLabel.closest('.price-changed-block, .tour-price-changed-block') : null;
                    var emoji = priceChangedContainer ? priceChangedContainer.querySelector('.emoji, .tour-price-changed-block__emoji') : null;
                    var priceRest = Number(responsePriceValue) - Number(currentPriceValue);
                    var absolutePriceRest = Math.abs(priceRest);
                    /**
                     * На сколько изменилась цена, считаем от старой цены
                     * @type {number}
                     */
                    var changePercent = priceRest / currentPriceValue * 100;

                    if (responsePriceValue > Number(currentPriceValue)) {
                        priceStatus = 'price-up';
                        if (str) {
                            str.textContent = 'повысилась';
                        }
                        if (emoji) {
                            emoji.attributes.src.value = '/x-assets/img/icons/emoji/thinking-face.png';
                        }
                    } else {
                        priceStatus = 'price-down';
                        if (str) {
                            str.textContent = 'понизилась';
                        }
                        if (emoji) {
                            emoji.attributes.src.value = '/x-assets/img/icons/emoji/happy-face.png';
                        }
                    }

                    if (!isMobile) {
                        dispatchRecalculateStatus(priceStatus, true, absolutePriceRest, response.currencySign);
                    } else {
                        if (priceChangedBlock) {
                            priceChangedBlock.classList.remove('hide');
                        }
                        if (priceRestLabel) {
                            priceRestLabel.innerText = absolutePriceRest.toLocaleString('ru-RU');
                        }
                        if (currentPriceLabel) {
                            currentPriceLabel.innerText = responsePriceValue.toLocaleString('ru-RU');
                        }
                        if (currentPriceValueElement) {
                            currentPriceValueElement.value = responsePriceValue;
                        }
                        if (currentCashbackSumLabel) {
                            currentCashbackSumLabel.innerText = '+' + responseCashbackValue.toLocaleString('ru-RU');
                        }
                        buttonNextStep.textContent = 'Оформить тур (' + responsePriceValue.toLocaleString('ru-RU') + ' ' + response.currencySign + ')';
                        buttonNextStep.setAttribute('data-price-checked', 'true');
                    }

                    var eventProperties = {};
                    eventProperties['Country id'] = response.countryId;
                    eventProperties['Tour id'] = response.tourId;
                    eventProperties['Increased value'] = priceRest;
                    eventProperties['Change percent'] = changePercent;
                    eventProperties['Current price'] = currentPriceValue;
                    eventProperties['New price'] = responsePriceValue;
                    eventProperties['New price sign'] = response.currencySign;
                    eventProperties['Operator Name'] = 'tourOperatorName' in response ? response.tourOperatorName : 'unknown';
                    eventProperties['Price status'] = priceStatus;
                    window.brxTracking.sendAnalyticsEvent('price_increased_after_recalculation', eventProperties);

                    buttonNextStep.disabled = false;
                    buttonNextStep.classList.remove('loader-btn');
                    return;
                }

                if (!response.isActual) {
                    if (!hasRecalculatedPrice) {
                        if (showNotActualTour(response)) {
                            buttonNextStep.disabled = false;
                            buttonNextStep.classList.remove('loader-btn');
                            return;
                        }

                        if (isMobile) {
                            if (priceChangedBlock) {
                                priceChangedBlock.classList.add('hide');
                            }
                            buttonNextStep.textContent = 'Оформить тур';
                            buttonNextStep.removeAttribute('data-price-checked');
                        } else {
                            dispatchRecalculateStatus('error', false);
                        }

                        buttonNextStep.disabled = false;
                        buttonNextStep.classList.remove('loader-btn');
                        return;
                    }

                    if (isMobile) {
                        window.scrollTo({
                            top: 85,
                            behavior: 'smooth'
                        });
                    }

                    var _priceChangedTitle = priceRestLabel ? priceRestLabel.closest('.main-text, .tour-price-changed-block__title') : null;
                    var _str = _priceChangedTitle ? _priceChangedTitle.querySelector('.change-str') : null;
                    var _priceChangedContainer = priceRestLabel ? priceRestLabel.closest('.price-changed-block, .tour-price-changed-block') : null;
                    var _emoji = _priceChangedContainer ? _priceChangedContainer.querySelector('.emoji, .tour-price-changed-block__emoji') : null;
                    var _priceRest = Number(responsePriceValue) - Number(currentPriceValue);
                    var _absolutePriceRest = Math.abs(_priceRest);
                    /**
                     * На сколько изменилась цена, считаем от старой цены
                     * @type {number}
                     */
                    var _changePercent = _priceRest / currentPriceValue * 100;

                    if (_absolutePriceRest === 0) {
                        if (showNotActualTour(response)) {
                            buttonNextStep.disabled = false;
                            buttonNextStep.classList.remove('loader-btn');
                            return;
                        }

                        buttonNextStep.disabled = false;
                        buttonNextStep.classList.remove('loader-btn');
                        return;
                    }

                    if (responsePriceValue > Number(currentPriceValue)) {
                        priceStatus = 'price-up';
                        if (_str) {
                            _str.textContent = 'повысилась';
                        }
                        if (_emoji) {
                            _emoji.attributes.src.value = '/x-assets/img/icons/emoji/thinking-face.png';
                        }
                    } else if (responsePriceValue < Number(currentPriceValue)) {
                        priceStatus = 'price-down';
                        if (_str) {
                            _str.textContent = 'понизилась';
                        }
                        if (_emoji) {
                            _emoji.attributes.src.value = '/x-assets/img/icons/emoji/happy-face.png';
                        }
                    }

                    if (!isMobile) {
                        dispatchRecalculateStatus(priceStatus, true, _absolutePriceRest, response.currencySign);
                    } else {
                        if (priceChangedBlock) {
                            priceChangedBlock.classList.remove('hide');
                        }
                        if (priceRestLabel) {
                            priceRestLabel.innerText = _absolutePriceRest.toLocaleString('ru-RU');
                        }
                        if (currentPriceLabel) {
                            currentPriceLabel.innerText = responsePriceValue.toLocaleString('ru-RU');
                        }
                        if (currentPriceValueElement) {
                            currentPriceValueElement.value = responsePriceValue;
                        }
                        if (currentCashbackSumLabel) {
                            currentCashbackSumLabel.innerText = '+' + responseCashbackValue.toLocaleString('ru-RU');
                        }
                        buttonNextStep.textContent = 'Оформить тур (' + responsePriceValue.toLocaleString('ru-RU') + ' ' + response.currencySign + ')';
                        buttonNextStep.setAttribute('data-price-checked', 'true');
                    }

                    var _eventProperties = {};
                    _eventProperties['Country id'] = response.countryId;
                    _eventProperties['Operator Name'] = 'tourOperatorName' in response ? response.tourOperatorName : 'unknown';
                    _eventProperties['Tour id'] = response.tourId;
                    _eventProperties['Increased value'] = _priceRest;
                    _eventProperties['Change percent'] = _changePercent;
                    _eventProperties['Price status'] = priceStatus;
                    _eventProperties['Current price'] = currentPriceValue;
                    _eventProperties['New price'] = responsePriceValue;
                    _eventProperties['New price sign'] = response.currencySign;
                    window.brxTracking.sendAnalyticsEvent('price_increased_after_recalculation', _eventProperties);
                } else {
                    completeAsActualWithoutPriceChange();
                }
            }

            function handleRecalculateError(error) {
                console.log('Ошибка пересчета тура:', error);
                buttonNextStep.disabled = false;
                buttonNextStep.classList.remove('loader-btn');
                buttonNextStep.textContent = 'Следующий шаг';
                if (isMobile && !isChangeFlight && finalNextStepButton) {
                    nextStepClickProcess();
                }

                if (!isMobile) {
                    dispatchRecalculateStatus('error', false);
                }
            }
        });

        function recalculateTour(successCallback, errorCallback, tourIdParentElemClass, tourIdTargetElemClass, flightIdsParentElemClass, flightIdsTargetElemClass, isAuto) {
            var recalculateTourManager = new RecalculateTourManager();

            recalculateTourManager.setTourIdElems(tourIdParentElemClass, tourIdTargetElemClass);
            recalculateTourManager.setFlightIdsElems(flightIdsParentElemClass, flightIdsTargetElemClass);
            var eventProperties = {};
            eventProperties['Is auto'] = isAuto;
            window.brxTracking.sendAnalyticsEvent('tour_calc_start', eventProperties);
            var recalculateTourManagerRequest = recalculateTourManager.setRecalculateTourLink(window.serviceLinks.links.recalculateTour ? window.serviceLinks.links.recalculateTour : '/new/online-booking/tour-recalculate');

            recalculateTourManagerRequest.sendRecalculateRequest(function (data) {
                if (typeof successCallback === 'function') {
                    successCallback(data);
                }
            }, function (error) {
                if (typeof errorCallback === 'function') {
                    errorCallback(error);
                }
            });
        }

        eventDispatcher.on('click', '.btn-close-price-changed', function (event, element) {
            var parent = element.closest('.price-changed-block');

            if (parent) {
                parent.classList.add('hide');
            }
        });
    }, { "../recalculate-tour-manager": 2 }], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var RecalculateTourManager = function () {
            function RecalculateTourManager() {
                _classCallCheck(this, RecalculateTourManager);

                this.linkRecalculateTour = null;
                this.tourIdParentElemClass = null;
                this.tourIdTargetElemClass = null;
                this.flightIdsParentElemClass = null;
                this.flightIdsTargetElemClass = null;
            }

            _createClass(RecalculateTourManager, [{
                key: "setRecalculateTourLink",
                value: function setRecalculateTourLink(link) {
                    this.linkRecalculateTour = link;
                    return this;
                }
            }, {
                key: "setTourIdElems",
                value: function setTourIdElems(tourIdParentElemClass, tourIdTargetElemClass) {
                    this.tourIdParentElemClass = tourIdParentElemClass;
                    this.tourIdTargetElemClass = tourIdTargetElemClass;
                }
            }, {
                key: "setFlightIdsElems",
                value: function setFlightIdsElems(flightIdsParentElemClass, flightIdsTargetElemClass) {
                    this.flightIdsParentElemClass = flightIdsParentElemClass;
                    this.flightIdsTargetElemClass = flightIdsTargetElemClass;
                }
            }, {
                key: "getTourId",
                value: function getTourId() {
                    var parent = document.querySelector(this.tourIdParentElemClass);
                    var container = parent ? parent.querySelector(this.tourIdTargetElemClass) : null;

                    return container ? container.dataset.id : null;
                }
            }, {
                key: "getFlightIds",
                value: function getFlightIds() {
                    var parent = document.querySelector(this.flightIdsParentElemClass);
                    var flights = parent ? parent.querySelectorAll(this.flightIdsTargetElemClass) : [];

                    var flightIds = [];

                    flights.forEach(function (item) {
                        flightIds.push(item.dataset.id);
                    });

                    return flightIds;
                }
            }, {
                key: "sendRecalculateRequest",
                value: function sendRecalculateRequest(successCallback, errorCallback) {
                    var params = {
                        tourId: this.getTourId(),
                        flightIds: this.getFlightIds()
                    };

                    if (!this.linkRecalculateTour || !params.tourId) {
                        if (typeof errorCallback === 'function') {
                            errorCallback(new Error('Invalid parameters'));
                        }
                        return;
                    }

                    ajax.get(this.linkRecalculateTour, { params: params }, function (data) {
                        if (data.success && data.responseData) {
                            if (typeof successCallback === 'function') {
                                successCallback(data);
                            }
                        } else {
                            console.error('Recalculation error:', data.error || 'Unknown error');
                            if (typeof errorCallback === 'function') {
                                errorCallback(data.error || 'Unknown error');
                            }
                        }
                    }, function (error) {
                        console.error('Recalculation request failed:', error);
                        if (typeof errorCallback === 'function') {
                            errorCallback(error || 'Unknown error');
                        }
                    });
                }
            }]);

            return RecalculateTourManager;
        }();

        module.exports = RecalculateTourManager;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var RecalculateTourManager = function () {
            function RecalculateTourManager() {
                _classCallCheck(this, RecalculateTourManager);

                this.linkRecalculateTour = null;
                this.tourIdParentElemClass = null;
                this.tourIdTargetElemClass = null;
                this.flightIdsParentElemClass = null;
                this.flightIdsTargetElemClass = null;
            }

            _createClass(RecalculateTourManager, [{
                key: "setRecalculateTourLink",
                value: function setRecalculateTourLink(link) {
                    this.linkRecalculateTour = link;
                    return this;
                }
            }, {
                key: "setTourIdElems",
                value: function setTourIdElems(tourIdParentElemClass, tourIdTargetElemClass) {
                    this.tourIdParentElemClass = tourIdParentElemClass;
                    this.tourIdTargetElemClass = tourIdTargetElemClass;
                }
            }, {
                key: "setFlightIdsElems",
                value: function setFlightIdsElems(flightIdsParentElemClass, flightIdsTargetElemClass) {
                    this.flightIdsParentElemClass = flightIdsParentElemClass;
                    this.flightIdsTargetElemClass = flightIdsTargetElemClass;
                }
            }, {
                key: "getTourId",
                value: function getTourId() {
                    var parent = document.querySelector(this.tourIdParentElemClass);
                    var container = parent ? parent.querySelector(this.tourIdTargetElemClass) : null;

                    return container ? container.dataset.id : null;
                }
            }, {
                key: "getFlightIds",
                value: function getFlightIds() {
                    var parent = document.querySelector(this.flightIdsParentElemClass);
                    var flights = parent ? parent.querySelectorAll(this.flightIdsTargetElemClass) : [];

                    var flightIds = [];

                    flights.forEach(function (item) {
                        flightIds.push(item.dataset.id);
                    });

                    return flightIds;
                }
            }, {
                key: "sendRecalculateRequest",
                value: function sendRecalculateRequest(successCallback, errorCallback) {
                    var params = {
                        tourId: this.getTourId(),
                        flightIds: this.getFlightIds()
                    };

                    if (!this.linkRecalculateTour || !params.tourId) {
                        if (typeof errorCallback === 'function') {
                            errorCallback(new Error('Invalid parameters'));
                        }
                        return;
                    }

                    ajax.get(this.linkRecalculateTour, { params: params }, function (data) {
                        if (data.success && data.responseData) {
                            if (typeof successCallback === 'function') {
                                successCallback(data);
                            }
                        } else {
                            console.error('Recalculation error:', data.error || 'Unknown error');
                            if (typeof errorCallback === 'function') {
                                errorCallback(data.error || 'Unknown error');
                            }
                        }
                    }, function (error) {
                        console.error('Recalculation request failed:', error);
                        if (typeof errorCallback === 'function') {
                            errorCallback(error || 'Unknown error');
                        }
                    });
                }
            }]);

            return RecalculateTourManager;
        }();

        module.exports = RecalculateTourManager;
    }, {}] }, {}, [1]);